module.exports = __webpack_public_path__ + "img/Notes-01-512.cf67fa36.svg";